<div class="d-md-flex align-items-center bg-white p-2" >
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14">Attività:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14" *ngIf="ListaScadenze">{{ListaScadenze.length}}</span>
  </span>
  <div class="ml-auto mt-3 mt-md-0">
    <button type="button" *ngIf="Padre" (click)="whoismyfather()" class="btn btn-purple rounded-pill p-2" ><i
      class="fas fa-tasks  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Vai ad attività padre</span>
    </button>
    <button type="button" (click)="ScadAddButton()" class="btn btn-cyan rounded-pill p-2" ><i
      class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Attività</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
    <tr>
      <th >Attività</th>
      <th scope="col">Inizio</th>
      <th scope="col">Fine</th>
      <th scope="col">Azioni</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let scadenza of ListaScadenze">
      <td>
        <span class="text-dark font-medium font-16">
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="info" class="feather-sm"></i-feather>
            </span>
          {{ scadenza.nome + " " + scadenza.manager.fullName}}
          </span>
      </td>
      <td class="align-middle">
        <span class="text-dark font-medium font-16">
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="info" class="feather-sm"></i-feather>
            </span>
          {{ scadenza.data_inizio_prevista | date: "dd/MM/yyyy"}}
        </span>
      </td>
      <td class="align-middle">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ scadenza.data_fine_prevista | date: "dd/MM/yyyy"}}
          </span>
      </td>
      <td class="align-middle">
        <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)="ScadModBtn(scadenza)">
          <i class="fas fa-pencil-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
